<template>
  <div class="agreement">
    <div class="title"><!--合同作废声明--></div>
    <div class="agreement-p">
      <p>甲方：</p>
      <p>乙方：</p>
      <p class="cancellation-height"></p>
      <p class="cancellation-info">
        甲方 与乙方签订的编号为XXXXXXXX合同，因为多方面原因，经双方协商决定解除该合同，特此说明。
      </p>
      <p class="cancellation-height"></p>
      <p>甲方：</p>
      <p>乙方：</p>
      <p>_____年_____月_____日</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cancellation',
  data() {
    return {};
  },
  mounted() {
    this.changeTitle();
  },
  methods: {
    changeTitle() {
      document.title = '合同作废声明';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agreement {
  height: 100%;
  background: #fff;
  font-size: 26px;
  color: #06112a;
}
.title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  line-height: 36px;
  padding: 30px 0 14px;
}
.agreement-p {
  padding: 0 32px;
}
.agreement-p p {
  line-height: 42px;
  text-align: justify;
}
.cancellation-height{
  height: 32px;
}
.p2 {
  font-weight: bold;
}
.cancellation-info {
  text-indent: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/view/cancellation.vue